/* eslint-disable */
import db from "../database";

 export default class DataLoader{

   GetStudents(){
       let UserRef=  db.collection("Users");
        return UserRef.where("isStudent","==",true);
    };
    Get(collection, property){
      console.log("collection: "+collection+"  property: "+property )
      let ref = db.collection(collection).where(property,"==",true);
      
      return ref;

    }


}
